import styled from 'styled-components'

export const WrapperReceipt = styled.div`
  .pageInner {
    position: relative;
    margin: 11px;
    .packageCount {
      position: absolute;
      top: 1px;
      left: 10px;
      background-color: #fff;
      font-size: 10px;
      z-index: 100;
      font-weight: bold;
    }
  }
  .page {
    position: relative;
    background: white;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.5cm;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
    width: 100mm;
    height: 70mm;
    color: #313131;
    padding-top: 1px;
  }

  .section {
    position: relative;
    display: flex;
    justify-content: space-between;
    border: 1px solid black;
    border-radius: 4px;
    .lable {
      position: absolute;
      background-color: white;
      top: -7px;
      right: 14px;
      font-size: 8px;
      padding: 0 3px;
      font-weight: bold;
    }
    .barcode-section {
      position: relative;
      border-right: 1px solid black;
      padding-top: 5px;
    }
    .logo-section {
      padding: 5px;
    }
    .orderId {
      text-align: center;
      width: 77px;
      height: 24px;
      position: absolute;
      top: 26px;
      right: -49px;
      transform: rotateZ(-270deg);
    }
    p {
      margin: 0;
    }
  }

  .sub-section {
    margin-left: 1px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .date-container {
    margin: 0 2px;
    direction: ltr;
    font-size: 10px;
    font-weight: bold;
  }

  .time-container {
    border-right: 2px solid gray;
    direction: ltr;
    padding-right: 2px;
    margin: 0 2px;
    font-size: 10px;
    font-weight: bold;
  }

  .payment-container {
    margin-right: 2px;
    direction: ltr;
    font-size: 9px;
    font-weight: bold;
  }
  .tracking-code {
    width: 100%;
    text-align: center;
    font-size: 10px;
    font-weight: bold;
  }

  .partner-address {
    font-size: 7px;
    font-weight: bold;
  }

  .flex-center {
    display: flex;
    align-items: center;
  }

  .flex-start {
    display: flex;
    align-items: start;
  }

  .receiver-section {
    position: relative;
    border: 3px solid #000;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    font-weight: bold;
    .lable {
      position: absolute;
      background-color: white;
      top: -10px;
      right: 14px;
      font-size: 8px;
      padding: 0 3px;
      font-weight: bold;
    }
    .receiver-name {
      display: flex;
      justify-content: space-between;
      padding: 4px 3px;
      border-bottom: 3px solid black;
    }
  }

  .order-table {
    width: 100%;
    border: 2px solid black;
    border-collapse: collapse;
    td {
      border: 2px solid black;
    }
  }

  main {
    border-radius: 4px;
  }

  @media print {
    body {
      width: 12.4;
      height: 10cm;
      margin: 30mm 45mm 30mm 45mm;
      -webkit-print-color-adjust: exact !important;
      /* change the margins as you want them to be. */
    }
    .page {
      margin: 0;
      position: relative;
      page-break-after: always;
      &:first-child {
        margin-top: -24px;
      }
    }
  }
`
